import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Row, Button, Col, Container, Stack } from "react-bootstrap";
import {
  itemRender,
  onShowSizeChange,
} from "../../components/paginationfunction";
import { Table } from "antd";
import axios from "axios";
import Header from "../Sidebar/header";
import Sidebar from "../Sidebar/settingsidebar";

const Designation = () => {
  const [menu, setMenu] = useState(false);
  const [inDept, setInDept] = useState([]);
  const [getdept, setGetDept] = useState([]);
  const [industrytype, setIndustrytype] = useState([]);
  const [getDes, setGetDes] = useState([]);
  const [designation, setDesignation] = useState([
    {
      name: "",
      description: "",
      inregid: null,
      dept_id: null,
    },
  ]);
  const token = sessionStorage.getItem("access_token");
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDeleteDes = (value) => {
    axios
      .delete(
        `${process.env.REACT_APP_BACKEND_URL}/tran_designation/`,
        // {
        //   off_id: 78,
        // },
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: {
            id: value.id,
            comp_id:sessionStorage.getItem("coid")
          },
        }
      )
      .then((res) => {
        alert("Delete Succesfully");
        handleGetDes();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGetDept = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/tran_department/`, {
        params: {
          draft: 1,
          coregid: sessionStorage.getItem("coid"),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setGetDept(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    handleGetDept();
  }, []);

  const handleDesignationpost = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/tran_designation/`,
        {
          coregid: sessionStorage.getItem("coid"),
          create_toggle: 1,
          dept_id: designation[0].dept_id,
          inregid: designation[0].inregid,
          name: designation[0].name,
          description: designation[0].description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        handleGetDes();
        setDesignation([
          {
            name: "",
            description: "",
            inregid: null,
            dept_id: null,
          },
        ]);
        // setCurrentTab(currentTab + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/gs_mas_industry/`, {
        // params: {
        //   empid: sessionStorage.getItem("emp_id"),
        // },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setIndustrytype(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/tran_department/`, {
        params: {
          coregid: sessionStorage.getItem("coid"),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setInDept(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleGetDes = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/tran_designation/`, {
        params: {
          draft: 1,
          coregid: sessionStorage.getItem("coid"),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        // setExdes(res.data);
        setGetDes(res.data);
        // setIndustrytype(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    handleGetDes();
  }, []);

  const handleFormChange = (index, event, state, setState) => {
    let data = [...state];
    console.log(index);
    console.log(event);
    data[index][event.target.name] = event.target.value;
    // data[index][event] = event.value;
    setState(data);
  };

  const handleFormChange1 = (index, event, state, setState, value) => {
    let data = [...state];
    console.log(index);
    console.log(event);
    data[index][value] = event.value;
    // data[index][event] = event.value;
    setState(data);
  };

  const columns = [
    {
      title: "Name of Designation",
      dataIndex: "desg",
      render: (text) => <p>{text?.name}</p>,
    },
    {
      title: "Name of Department",
      dataIndex: "dept",
      render: (text) => <p>{text?.name}</p>,
    },
    {
      title: "Description",
      dataIndex: "desg",
      render: (text) => <p>{text?.description}</p>,
    },
    {
      title: "Action",
      // dataIndex: "city",
      render: (text) => (
        <div>
          {/* <button
            className="noborder"
            onClick={() => setEditOffice(text)}
            data-bs-toggle="modal"
            data-bs-target="#edit_office_board"
            href="#"
          >
            Edit
          </button> */}
          
          <button className="noborder" onClick={() => handleDeleteDes(text)}>
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />

      <Sidebar />
      <div className="page-wrapper">
        {/* <Helmet>
        <title>Leaves - HRMS Admin Template</title>
        <meta name="description" content="Login page" />
      </Helmet> */}

        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Designation</h3>
                {/* <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/app/main/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Leaves</li>
              </ul> */}
              </div>
              <div className="col-auto float-end ml-auto">
                <div className="view-icons">
                  <button
                    className="btn btn-success btn-block "
                    style={{
                      padding: "8px 23px",
                      fontSize: "15px",
                      background: "#168e9e",
                      border: "none",
                      color: "white",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#add_desi_board"
                    href="#"
                  >
                    Add New
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Leave Statistics */}

          {/* /Leave Statistics */}
          <div className="row">
            <div className="col-md-12">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={getDes}
                      pagination={{
                        total: getDes.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="add_desi_board"
          className="modal custom-modal fade"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Designation </h4>
                <button type="button" className="close" data-bs-dismiss="modal">
                  {/* <img src={closeIcon} /> */}
                </button>
              </div>
              <div className="modal-body">
                {designation.map((input, index) => (
                  <form action="#">
                    <div className="row">
                      {/* <h5>{`Designation ${index + 1}`}</h5> */}
                      <div className="form-group col-md-6">
                        <label> Name of Designation</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          value={input.name}
                          onChange={(event) =>
                            handleFormChange(
                              index,
                              event,
                              designation,
                              setDesignation
                            )
                          }
                        />
                      </div>
                      <div className="form-group  col-md-6">
                        <label>Designation Type</label>
                        <Select
                          options={industrytype}
                          value={industrytype?.find(
                            (ele) => ele.value === input.inregid
                          )}
                          onChange={(event) =>
                            handleFormChange1(
                              index,
                              event,
                              designation,
                              setDesignation,
                              "inregid"
                            )
                          }
                        />
                      </div>
                      <div className="form-group  col-md-6">
                        <label>Department Name</label>
                        <Select
                          options={inDept}
                          value={inDept?.find((ele) => ele.value === input.id)}
                          onChange={(event) =>
                            handleFormChange1(
                              index,
                              event,
                              designation,
                              setDesignation,
                              "dept_id"
                            )
                          }
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <label> Designation Description</label>
                        <input
                          type="text"
                          name="description"
                          className="form-control"
                          value={input.description}
                          onChange={(event) =>
                            handleFormChange(
                              index,
                              event,
                              designation,
                              setDesignation
                            )
                          }
                        />
                      </div>
                    </div>
                  </form>
                ))}
                <div className="m-t-20 text-center">
                  <button
                    data-bs-dismiss="modal"
                    className="submit-btn"
                    onClick={(e) => handleDesignationpost()}
                    style={{ fontSize: "16px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Designation;
